// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1ltwS","large":"styles_large__1ShXc"};